import { getLanguage } from '../services/getLanguage';

export function getOnpremHostname(): string {
  if (process.env.REACT_APP_OMNI_CORE_MOCK_API === 'true') {
    return '/api';
  }

  const context = process.env.REACT_APP_OMNI_CORE_USER_CONTEXT.toLowerCase();
  const businessCode = process.env.REACT_APP_OMNI_CORE_BUSINESS_ENTITY_CODE.toLowerCase();
  switch (context) {
    case 'client':
      switch (businessCode) {
        case '0':
          return process.env.REACT_APP_OMNI_CORE_ONPREM_IA_CLIENT;
        case '6':
          return process.env.REACT_APP_OMNI_CORE_ONPREM_INVESTIA_CLIENT;
        case '14':
          return getLanguage() === 'fr'
            ? process.env.REACT_APP_OMNI_CORE_ONPREM_WEALTH_CLIENT_FR
            : process.env.REACT_APP_OMNI_CORE_ONPREM_WEALTH_CLIENT_EN;
        default:
          throw new Error(`company not supported : ${businessCode} for context : ${context}`);
      }
    case 'advisor':
      switch (businessCode) {
        case '0':
          return process.env.REACT_APP_OMNI_CORE_ONPREM_IA_ADVISOR;
        default:
          throw new Error(`company not supported : ${businessCode} for context : ${context}`);
      }
    case 'dealer': {
      const dealersExperience = sessionStorage.getItem('dealersExperience') ?? 'unifi';
      switch (businessCode) {
        case '0':
        case '1':
          switch (dealersExperience.toLowerCase()) {
            case 'genesis':
              return process.env.REACT_APP_OMNI_CORE_ONPREM_IA_DEALER_GENESIS;
            case 'honda':
              return process.env.REACT_APP_OMNI_CORE_ONPREM_IA_DEALER_HONDA;
            case 'hyundai':
              return process.env.REACT_APP_OMNI_CORE_ONPREM_IA_DEALER_HYUNDAI;
            case 'acura':
              return process.env.REACT_APP_OMNI_CORE_ONPREM_IA_DEALER_ACURA;
            case 'unifi':
              return process.env.REACT_APP_OMNI_CORE_ONPREM_IA_DEALER_UNIFI;
            default:
              throw new Error(`dealer experience not supported : ${dealersExperience} for context : ${context}`);
          }
        default:
          throw new Error(`company not supported : ${businessCode} for context : ${context}`);
      }
    }
    case 'partner':
      switch (businessCode) {
        case '0':
          return process.env.REACT_APP_OMNI_CORE_ONPREM_IA_PARTNER;
        default:
          throw new Error(`company not supported : ${businessCode} for context : ${context}`);
      }

    default:
      throw new Error(`context not supported : ${context}`);
  }
}
